module.exports = __webpack_public_path__ + "img/ic_food_western.50b63546.png";